
enum Result {
  SUCCESS = 'Success',
  FAIL = 'Fail',
}

export default Result;
